var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.672 6.73334H8.80534V4.13334C8.80534 2.22667 7.24534 0.666672 5.33867 0.666672C3.432 0.666672 1.87201 2.22667 1.87201 4.13334V6.73334H1.00534C0.572005 6.73334 0.138672 7.16667 0.138672 7.60001V13.6667C0.138672 14.1 0.572005 14.5333 1.00534 14.5333H9.672C10.1053 14.5333 10.5387 14.1 10.5387 13.6667V7.60001C10.5387 7.16667 10.1053 6.73334 9.672 6.73334ZM7.072 6.73334H3.60534V4.13334C3.60534 3.18001 4.38534 2.40001 5.33867 2.40001C6.29201 2.40001 7.072 3.18001 7.072 4.13334V6.73334Z",
    fill: "#374151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLock);
export default __webpack_public_path__ + "static/media/full-lock.12e97ff3.svg";
export { ForwardRef as ReactComponent };